import { DefaultValueConfig } from '@headless-workspace/config';
import { ImageWithSrc } from '@headless-workspace/typings';
import { ObjectHelpers, StringHelpers } from '@headless-workspace/utils';
import { FooterReinsuranceDTO } from './FooterSlotsDTO';

export type FooterReinsuranceValue = Readonly<{
    id: string;
    image: ImageWithSrc;
    title: string;
    description: string;
    cta: {
        href: string;
        label: string;
    };
}>;

export const mapFooterReinsurance = (dto: FooterReinsuranceDTO): FooterReinsuranceValue[] => {
    return dto.details.items.map((item, index) => ({
        id: `reinsurance-${index}`,
        image: ObjectHelpers.createImageWithSrc(item.image.icon),
        title: StringHelpers.decodeSpecialChars(item.title),
        description: StringHelpers.decodeSpecialChars(item.description),
        cta: {
            href: item.cta.link ?? DefaultValueConfig.href,
            label: StringHelpers.decodeSpecialChars(item.cta.label),
        },
    }));
};
